var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('custom-select',{attrs:{"items":_vm.getRangejercicios,"label":_vm.label,"hide-details":""},model:{value:(_vm.getEjercicio),callback:function ($$v) {_vm.getEjercicio=$$v},expression:"getEjercicio"}})}
var staticRenderFns = []

export { render, staticRenderFns }